import React, {Component} from 'react';
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {Tooltip, Table} from 'antd';
import {CopyOutlined} from "@ant-design/icons";
import {TrackStates} from "./types/TrackTypes";
import withAuth from "../../hoc/withAuth";
import TrackTemplate from "../../config/data/trackTemplate";

export interface TrackProps {
}

class Track extends Component<TrackProps & any, TrackStates> {
    private readonly initState!: TrackStates;
    private tableColumn: any = [
        {
            title: 'Kode Template',
            dataIndex: 'template',
            render: ((value: string, row: []) => {
                return (
                    <React.Fragment>
                        <span className={`font-90`}>{value}</span>
                        &nbsp; &nbsp;
                        <Tooltip title="Click untuk copy kode template" color={'cyan'}>
                            <CopyOutlined className={'small-avatar-link'} onClick={event => this.copyToClipboard(value)}/>
                        </Tooltip>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Deskripsi',
            dataIndex: 'message',
            render: (value: string) => {
                return <span className={`font-90`}>{value}</span>
            }
        },
        {
            title: 'Dapat Dilihat Oleh',
            dataIndex: 'visible_targets',
            render: (value: string) => {
                return <span className={`font-90`}>{value.toString()}</span>
            }
        },
        {
            title: 'Trigger',
            dataIndex: 'external_info',
            render: (value: any) => {
                return <span className={`font-90`}>{value?.trigger}</span>
            }
        },
        {
            title: 'external_data',
            dataIndex: 'external_info',
            render: (value: any) => {
                return <span className={`font-90`}>{value?.external_data.toString()}</span>
            }
        },
        {
            title: 'Active',
            dataIndex: 'active',
            render: (value: string) => {
                return <span className={`font-90`}>{value.toString()}</span>
            }
        },
    ]

    constructor(props: TrackProps & any | any) {
        super(props);

        this.initState = {
            processing: false,
            processingFetchTableData: true,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            dataTrack: [],
            pageSize: 500,
        }
        this.state = {...this.initState}
    }

    copyToClipboard = async (data: any) => {
        await navigator.clipboard.writeText(data);
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            processingFetchTableData: true,
            dealerCode: data.value,
        });

        await this.fetchTrackTemplate();
    }

    fetchTrackTemplate = async () => {
        const dataTemplate: any = [];
        let i = 0;
        for (const [key, value] of Object.entries(TrackTemplate)) {
            dataTemplate.push(value);
            dataTemplate[i].template = key;
            i++;
        }

        await this.promisedSetState({
            dataTrack: dataTemplate,
            processingFetchTableData: false,
        });
    }

    onChangeTable = (pagination: any, filters: any, sorter: any) => {
        if (pagination?.pageSize) {
            this.setState({
                pageSize: pagination?.pageSize,
            });
        }
    }

    async componentDidMount() {
        await this.fetchTrackTemplate();
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Setting`} breadcrumbMenu={`Track`} defaultSelectedKeys={['m-setting-track']} defaultOpenKeys={['sm-setting']}>
                    <Table
                        rowKey={'template'}
                        size={'small'}
                        scroll={{x: 'calc(500px + 50%)'}}
                        loading={this.state.processingFetchTableData}
                        columns={this.tableColumn}
                        dataSource={this.state.dataTrack}
                        pagination={{pageSize: this.state.pageSize}}
                        onChange={this.onChangeTable}
                    />
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(Track), 18));
